import { render, staticRenderFns } from "./BankTransferCollapse.vue?vue&type=template&id=3c4d0d1b&scoped=true&"
import script from "./BankTransferCollapse.vue?vue&type=script&lang=js&"
export * from "./BankTransferCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferCollapse.vue?vue&type=style&index=0&id=3c4d0d1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d0d1b",
  null
  
)

export default component.exports